
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class ReceiptDenominationDetailsDialog extends Serenity.EntityDialog<ReceiptDenominationDetailsRow, any> {
        protected getFormKey() { return ReceiptDenominationDetailsForm.formKey; }
        protected getIdProperty() { return ReceiptDenominationDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return ReceiptDenominationDetailsRow.localTextPrefix; }
        protected getService() { return ReceiptDenominationDetailsService.baseUrl; }
        protected getDeletePermission() { return ReceiptDenominationDetailsRow.deletePermission; }
        protected getInsertPermission() { return ReceiptDenominationDetailsRow.insertPermission; }
        protected getUpdatePermission() { return ReceiptDenominationDetailsRow.updatePermission; }

        protected form = new ReceiptDenominationDetailsForm(this.idPrefix);

    }
}